import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input";
import * as S from "../Login.styled";
import { requestPasswordReset } from "../../../Utils/authService";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [notification, setNotification] = useState({
    message: "",
    type: "success",
  });

  const showNotification = (message, type) => {
    setNotification({ message, type });
    window.setTimeout(() => {
      setNotification({ message: "", type: "success" });
    }, 4000);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await requestPasswordReset(email);
      // SECURITY: never surface the reset token in the UI. The reset flow must
      // go through the emailed /reset-password?token= link only.
      showNotification(
        response?.message ||
          t("login.reset_sent", "If the email exists, a reset link was sent."),
        "success"
      );
    } catch (error) {
      showNotification(
        t("login.reset_error", "Could not request password reset."),
        "error"
      );
    }
  };

  return (
    <S.Page>
      <S.FormWrapper>
        <S.FormHeader>
          <h1>{t("login.forgot_title") || "Forgot Password"}</h1>
        </S.FormHeader>
        <S.Form onSubmit={handleSubmit}>
          <Input
            id="email"
            name="email"
            label={t("login.email") || "Email"}
            placeholder={t("login.email_placeholder") || "example@example.com"}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {notification.message ? (
            <S.Notification $type={notification.type} role="status">
              {notification.message}
            </S.Notification>
          ) : null}
          <Button type="submit" variant="primary" fullWidth>
            {t("login.reset_request", "Send reset link")}
          </Button>
        </S.Form>
        <S.ToggleText>
          {t("login.toggle_existing") || "Remembered your password?"}{" "}
          <S.ToggleAction type="button" onClick={() => navigate("/login")}>
            {t("login.toggle_login") || "Log In"}
          </S.ToggleAction>
        </S.ToggleText>
      </S.FormWrapper>
    </S.Page>
  );
};

export default ForgotPasswordPage;
